import React, { useState } from 'react';
import {
    MessageBar,
    MessageBarBody,
    MessageBarActions,
    Button,
    makeStyles,
} from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';
import { isDismissed, dismissNotification } from '../utils/notificationStorage';

interface BannerProps {
    message: string;
    id: string;
    severity?: 'warning' | 'info';
}

const useStyles = makeStyles({
    container: {
        position: 'sticky',
        top: '0px',
        width: '80%',
        maxWidth: '1000px',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: '-48px',
        zIndex: 1000,
    },
    messageBar: {
      padding: '15px 10px 10px 15px',
    },
    messageBarBody: {
      margin: '0',
      padding: '0',
      '& *:last-child': { margin: '0' },
      '& h1, h2, h3': { fontSize: '1.3em' },
      '& a': { color: 'rgb(58, 163, 63)' },
      '& a:hover': { color: 'rgb(34, 139, 34)' },
    },
});

const NotificationBanner: React.FC<BannerProps> = ({ message, id, severity = 'info' }) => {
    const classes = useStyles();
    const [isVisible, setIsVisible] = useState(!isDismissed(id));

    if (!isVisible) {
        return null;
    }

    const handleDismiss = () => {
        dismissNotification(id);
        setIsVisible(false);
    };

    return (
        <div className={classes.container}>
            <MessageBar intent={severity} className={classes.messageBar}>
                <MessageBarBody className={classes.messageBarBody}>
                    <span dangerouslySetInnerHTML={{ __html: message }} />
                </MessageBarBody>
                <MessageBarActions
                    containerAction={
                        <Button
                            appearance="transparent"
                            icon={<DismissRegular />}
                            onClick={handleDismiss}
                            aria-label="Close"
                        />
                    }
                />
            </MessageBar>
        </div>
    );
};

export default NotificationBanner;